import React, { useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Link, useLocation } from 'react-router-dom';

import useResponsive from '../../../hooks/useResponsive';
import { SidebarActionCreators } from '../../../redux/actions/creators';
import { releaseFlags } from '../../../../helpers/featuresFlags/featuresFlags';
import mePropTypes from '../../../../shared/propTypes/mePropTypes';

import styles from '../../../styles/views/components/SidebarMenu/SidebarMenuItems.module.scss';

const translationOptions = { ns: i18next.Namespace.COMMON };

const SidebarMenuItems = ({ me }) => {
  const location = useLocation();
  const { isDesktop } = useResponsive();
  const dispatch = useDispatch();
  const [t] = useTranslation();

  const menuLinks = me.allowedPageRoutes.filter((route) => route.isInSidebar);

  const checkActiveLinks = (link) => (link.path === location.pathname ? 'active' : '');

  const handleLinkClick = useCallback(() => {
    if (!isDesktop) dispatch(SidebarActionCreators.collapseSidebar());
  }, [isDesktop, dispatch]);

  return (
    <ul className={styles.linkGroup}>
      {menuLinks
        .filter((link) => !releaseFlags.isFlaggingEnabled || releaseFlags[me.role][link.path.split('/')[1]]?.isShown || link.path === '#')
        .map((link) => (
          <li
            className={`${styles.linkWrapper} ${styles[checkActiveLinks(link)]}`}
            key={link.path}
            onClick={handleLinkClick}
          >
            <div className={styles.link}>
              <Link to={link.path}>{t(link.transKey, translationOptions)}</Link>
            </div>
          </li>
        ))
      }
      <li className={styles.signOutLink}>
        <Link id="signOutLink" to="/logout">{t('button.signOut', { ns: i18next.Namespace.COMMON })}</Link>
      </li>
    </ul>
  );
};

SidebarMenuItems.propTypes = {
  me: mePropTypes.isRequired,
};

export default memo(SidebarMenuItems);
